import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { DialogComponent } from '@features/dialog/dialog/dialog.component';
import { transform } from '@shared/animations/animations.functions';
import { TranslateSafePipe } from '@shared/translate-safe/translate-safe.pipe';
import { SvgIconComponent } from '@shared/svg-icon/svg-icon.component';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-dialog-sidebar',
    templateUrl: './dialog-sidebar.component.html',
    styleUrls: ['./dialog-sidebar.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [
        transform({ trigger: 'dialogSlideIn', property: 'translateX', valueFrom: '100%', valueTo: '0', fadeIn: true })
    ],
    imports: [NgClass, SvgIconComponent, TranslateSafePipe]
})
export class DialogSidebarComponent extends DialogComponent {
    @Input() stickyHeader: boolean = false;
}
